// import { ConfigurationObject } from '../globals/Interfaces';

import { Resources } from '../globals/interfaces';
import { ResourceService } from '../services/resource.service';
import * as Constants from '../globals/constants';
import { BuildingClass } from './building.class';
import { PopulationService } from '../services/population.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { TechnologyService } from '../services/technology.service';

/**
 * @internal
 * A base class for production buildings.
 */
export abstract class ProductionClass extends BuildingClass {
  public reseachMultiplier: number;
  public productionPerMinute: Resources;
  public numberOfBuildings;
  public resourceHandler;
  public technologyHandler;
  public buildingCosts;

  public produced: Resources;

  protected populationEfficienty;
  private populationUpdate: BehaviorSubject<any>;

  protected constructor(resourceService: ResourceService, populationService: PopulationService, technologyService: TechnologyService) {
    super(resourceService, populationService, technologyService);
    this.numberOfBuildings = 0;
    this.produced = {
      food: 0,
      wood: 0,
      population: 0,
      stone: 0,
      metal: 0,
      gold: 0,
      power: 0,
      data: 0,
    };
    this.buildingCosts = {};
    this.reseachMultiplier = 1;
    this.populationUpdate = this.populationService.populationUpdate.subscribe((efficiency) => {
      this.populationEfficienty = efficiency;
    });
  }

  public produce(timePassed) {
    const resourceList = Object.entries(this.productionPerMinute);
    resourceList.forEach((resource) => {
      let powerEfficiency = 1;
      if (this.technologyService.state.power_plants) {
        powerEfficiency = this.resourceService.calculatePowerEfficiency();
      }
      this.produced[resource[0]] += ((resource[1] / 60000) * timePassed)
      * this.numberOfBuildings
      * this.reseachMultiplier
      * this.populationEfficienty
      * powerEfficiency;
    });
  }

  public resourcesProduced() {
    const resourceList = Object.entries(this.produced);
    resourceList.forEach((resource) => {
      if (this.produced[resource[0]] > 1) {
        const produced = Math.floor(this.produced[resource[0]]);
        this.produced[resource[0]] -= produced;
        this.resourceService.addResource(resource[0], produced);
      }
    });
  }

  public initBuilding(name, id, building) {
    super.initBuilding(name, id, building);
    this.productionPerMinute = building.PRODUCTION;
  }
}
